/**
 * File: ProductsPage.js
 * Origin: isotect
 * Description: [TODO: Description]
 *
 * Version: v1.6.1
 * Created: 2025-11-11
 * Last Updated: 2026-06-22
 *
 * Used By: isotect
 * Maintainer: Zachary Dicks
 *
 * Notes:
 * - Changes in this file may affect all consuming frontend modules.
 * - See Git repository 'isotect' for full change history.
 */

// Third-party packages
import { useNavigate } from "react-router-dom";
import { useState } from "react";

// Local project files
import { ChatButton } from "../components/ui/Buttons";
import { ImageHero } from "../components/layout/Hero";
import { routes } from "../constants/routes";
import ContactModal from "../components/layout/ContactModal";
import Grid from "../components/layout/Grid";
import QuoteModal from "../components/layout/QuoteModal";
import WaitlistModal from "../components/layout/WaitlistModal";

/**
 * [TODO: Component description here]
 *
 * @returns {JSX.Element} [TODO: Rendered output]
 */
function ProductsPage({ schema }) {
    const navigate = useNavigate();

    const [contactModal, setContactModal] = useState(false);
    const [waitlistModal, setWaitlistModal] = useState(false);
    const [quoteModal, setQuoteModal] = useState(false);

    const redirectSignUpPage = () => {
        navigate(routes.public.auth.signUp.abs);
    };

    const toggleContactModal = () => {
        setContactModal((prev) => !prev);
    };

    const closeContactModal = () => {
        setContactModal(false);
    };

    const toggleWaitlistModal = () => {
        setWaitlistModal((prev) => !prev);
    };

    const closeWaitlistModal = () => {
        setWaitlistModal(false);
    };

    const toggleQuoteModal = () => {
        setQuoteModal((prev) => !prev);
    };

    const closeQuoteModal = () => {
        setQuoteModal(false);
    };

    let primaryOnClick = redirectSignUpPage;
    if (schema.meta.id === "products-page") {
        primaryOnClick = toggleWaitlistModal;
    } else if (schema.meta.id === "services-page") {
        primaryOnClick = toggleQuoteModal;
    }

    return (
        <>
            {waitlistModal && <WaitlistModal onClose={closeWaitlistModal} />}
            {quoteModal && <QuoteModal onClose={closeQuoteModal} />}
            {contactModal && <ContactModal onClose={closeContactModal} />}
            <ChatButton onClick={toggleContactModal} />

            <div key={schema.meta.id} className="products-page">
                <article className="products-page__hero-article u-fade-in">
                    <div className="products-page__container">
                        <ImageHero
                            {...schema.hero}
                            primaryOnClick={primaryOnClick}
                            secondaryOnClick={toggleContactModal}
                        />
                    </div>
                </article>
                <article className="products-page__grid-article u-fade-in">
                    <div className="products-page__container">
                        <Grid items={schema.gridItems} />
                    </div>
                </article>
            </div>
        </>
    );
}

export default ProductsPage;
